const es = {
    transactionTypes: {
        adjustment: 'Ajuste',
        authorization: 'Autorización',
        cashAdvance: 'Adelanto en efectivo',
        credit: 'Crédito',
        default: 'Transacción',
        fee: 'Cobro',
        interest: 'Interés',
        lateFee: 'Tarifa por mora',
        payment: 'Pago',
        purchase: 'Compra',
        refund: 'Reembolso'
    },
    common: {
        apiErrorHeading: 'Oops...',
        apiErrorMessage: 'Lamentablemente no podemos procesar su solicitud en este momento.\n Por favor, intente nuevamente más tarde.',
        backButton: 'Regresar',
        closeButton: 'Cerrar'
    },
    promotions: {
        accordionHeading: 'Detalles de Términos Promocionales',
        accordionText: 'Esta tabla de contenido muestra un resumen de sus compras promocionales, incluidos los tipos de promociones en su cuenta.  Para obtener más detalles, incluso los términos de la promoción, consulte su estado de cuenta.',
        activePromotionsHeading: 'Promociones Actuales',
        deferredInterestChargesCellValue: 'Cargos por Interés\n Diferido',
        deferredInterestChargesTableHeader: 'Cargos por Interés\n Diferido',
        descriptionTableHeader: 'Detalles de las Promociones / Términos Especiales',
        detailsChartAmountPaidLabel: 'Monto Pagado',
        detailsChartHeading: 'Progreso de la Promoción',
        detailsChartRemainingDaysLabel: 'Días restantes del período promocional',
        detailsDeferredInterestChargesLabel: 'Cargos por Interés Diferido',
        detailsExpirationDateLabel: 'Fecha de Vencimiento',
        detailsPromotionalBalanceLabel: 'Saldo Promocional',
        detailsPromotionDetailsHeading: 'Detalles de las Promociones',
        detailsPurchaseAmountLabel: 'Monto de la Compra',
        detailsPurchaseDateLabel: 'Fecha de Compra',
        detailsSpecialTermsLabel: 'Términos Especiales',
        expirationDateCellValue: 'Fecha de\n Vencimiento',
        expirationDateTableHeader: 'Fecha de\n Vencimiento',
        expiredPromotionsHeading: 'Promociones Inactivas',
        noPromotionsMessage: 'No tiene promociones en este momento',
        pastPromotionPeriodHeading: 'Su período promocional ha transcurrido.',
        promotionalBalanceHeader: 'Saldo\n Promocional',
        promotionalBalanceTooltip: 'El Saldo Promocional se refiere al saldo que se adeuda en esta promoción',
        promotionPaidHeading: '¡Felicitaciones!',
        promotionPaidSubHeading: 'Su saldo ha sido liquidado.',
        promotionsTableCaption: 'Promociones',
        purchaseAmountDateCellValue: 'Monto de la\n Compra',
        purchaseDateCellValue: 'Fecha de\n Compra',
        purchaseDateTableHeader: 'Fecha de\n Compra',
        untilPaidOffCellValue: 'Hasta Pagar la Totalidad'
    }
};
export default es;
//# sourceMappingURL=es.js.map